export const TEMPLATE_EDIT_SESSION_GAP_MS = 10 * 60 * 1000

export const TEMPLATE_SESSION_TYPE = 'TEMPLATE_SESSION'

const TEMPLATE_EVENT_TYPES = [
  'ADD_TEMPLATE_ITEM',
  'REMOVE_TEMPLATE_ITEM',
  'MOVE_TEMPLATE_ITEM',
  'EDIT_TEMPLATE_ITEM',
  'ATTACH_TEMPLATE_DOCUMENT',
  'DETACH_TEMPLATE_DOCUMENT',
]

const HIDDEN_EVENT_TYPES = ['VIEW_CALL']

export type TimelineEvent = {
  type: string
  timestamp: Date | string
  userName: string | null
  metadata: any | null
}

export type TimelineGroup = {
  type: string
  userName: string | null
  firstTimestamp: Date
  lastTimestamp: Date
  events: TimelineEvent[]
  detailEvents: TimelineEvent[]
}

function timeOf(event: TimelineEvent): number {
  return new Date(event.timestamp).getTime()
}

function isTemplateEvent(event: TimelineEvent): boolean {
  return TEMPLATE_EVENT_TYPES.includes(event.type)
}

function continuesSession(group: TimelineGroup, event: TimelineEvent, gapMs: number): boolean {
  return (
    isTemplateEvent(event) &&
    group.type === TEMPLATE_SESSION_TYPE &&
    group.userName === event.userName &&
    timeOf(event) - group.lastTimestamp.getTime() <= gapMs
  )
}

function startGroup(event: TimelineEvent): TimelineGroup {
  return {
    type: isTemplateEvent(event) ? TEMPLATE_SESSION_TYPE : event.type,
    userName: event.userName,
    firstTimestamp: new Date(timeOf(event)),
    lastTimestamp: new Date(timeOf(event)),
    events: [event],
    detailEvents: isTemplateEvent(event) ? [event] : [],
  }
}

function absorb(group: TimelineGroup, event: TimelineEvent): void {
  group.events.push(event)
  group.detailEvents.push(event)
  group.lastTimestamp = new Date(timeOf(event))
}

export function groupTimelineEvents(events: TimelineEvent[], gapMs: number = TEMPLATE_EDIT_SESSION_GAP_MS): TimelineGroup[] {
  return events
    .filter((event) => !HIDDEN_EVENT_TYPES.includes(event.type))
    .sort((first, second) => timeOf(first) - timeOf(second))
    .reduce<TimelineGroup[]>((groups, event) => {
      const openGroup = groups.at(-1)
      if (openGroup === undefined || !continuesSession(openGroup, event, gapMs)) {
        return [...groups, startGroup(event)]
      }

      absorb(openGroup, event)
      return groups
    }, [])
}
